import React from 'react';
import { Check, X } from 'lucide-react';
import { COMPARISON_FEATURES, TIERS } from './tiersData';

const renderCell = (value: string | boolean, highlight: boolean) => {
  if (value === true) {
    return (
      <Check
        className={`w-5 h-5 mx-auto ${highlight ? 'text-primary-400' : 'text-emerald-400'}`}
        aria-label="Incluído"
      />
    );
  }
  if (value === false) {
    return (
      <X className="w-5 h-5 mx-auto text-neutral-600" aria-label="Não incluído" />
    );
  }
  return <span className={`text-sm ${highlight ? 'text-white font-medium' : 'text-neutral-300'}`}>{value}</span>;
};

export const PricingComparisonTable: React.FC = () => {
  return (
    <section
      aria-labelledby="comparison-heading"
      className="max-w-6xl mx-auto mb-16 sm:mb-20"
    >
      <h2
        id="comparison-heading"
        className="text-2xl sm:text-3xl font-bold text-white text-center mb-8 sm:mb-10"
      >
        Compare todos os recursos
      </h2>

      <div
        role="region"
        aria-label="Comparação completa de planos"
        tabIndex={0}
        className="overflow-x-auto -mx-4 sm:mx-0 rounded-2xl border border-neutral-700/50 bg-neutral-900/60 backdrop-blur-xl focus:outline-none focus:ring-2 focus:ring-primary-500/50"
      >
        <table className="w-full min-w-[640px] text-left">
          <thead>
            <tr className="border-b border-neutral-700/50">
              <th scope="col" className="p-4 sm:p-5 text-sm font-semibold text-neutral-400">
                Recurso
              </th>
              {TIERS.map((tier) => (
                <th
                  key={tier.id}
                  scope="col"
                  className={`p-4 sm:p-5 text-center text-sm font-semibold ${
                    tier.highlight ? 'text-primary-400' : 'text-white'
                  }`}
                >
                  {tier.name}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {COMPARISON_FEATURES.map((row, index) => (
              <tr
                key={row.label}
                className={`border-b border-neutral-800/50 ${
                  index % 2 === 0 ? 'bg-neutral-900/20' : ''
                }`}
              >
                <th
                  scope="row"
                  className="p-4 sm:p-5 text-sm font-medium text-neutral-300 align-middle"
                >
                  {row.label}
                </th>
                <td className="p-4 sm:p-5 text-center align-middle">
                  {renderCell(row.free, false)}
                </td>
                <td className="p-4 sm:p-5 text-center align-middle bg-primary-500/5">
                  {renderCell(row.pro, true)}
                </td>
                <td className="p-4 sm:p-5 text-center align-middle">
                  {renderCell(row.business, false)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
};
